module.exports = __webpack_public_path__ + "images/emoji/man_with_turban.e5c1810f71b5de8f64af.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/man_with_turban.png
// module id = m4+E
// module chunks = 1